<div class="modal-body px-3 py-3">
  <div class="d-flex justify-content-between mb-2">
    <div>
      <span class="font-weight-600">
        Share Project
      </span>
    </div>
    <span class="pointer">
      <i class="far fa-times f-16" (click)="closeModal('skip')"> </i>
    </span>
  </div>

  <div class="row mt-2">
    <div class="col-12 heading-text">
      <p class="text-9696 mb-2 f-12">
        Project name
      </p>
    </div>
    <div class="col-12">
      <div class="w-100">
        <div class="d-flex f-12 flex-wrap mb-2">
          <span class="f-14 mb-4" >
            <span class="talentpool-chip mr-2 px-2 py-1 mb-1">{{selectedProject?.projectname}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <p class="f-14 font-weight-500 mb-2">Share this project to</p>
    </div>
    <div class="col-12">
      <div class="row mb-3px ml-0" *ngIf="allTeamMembers?.length">
        <div class="col-md-4 pl-0 mb-3" *ngFor="let member of allTeamMembers">
          <div class="wccard card-data px-3 py-2 d-flex justify-content-between flex-column" [ngClass]="{'border-selected': member.projectshared, 'border-unselected': !member.projectshared}">
            <div class="">
              <div class="">
                <div class="position-relative w-100 d-flex">
                  <label class="wc-checkbox mr-2 mb-0 d-flex">
                    <input data-testid="auto-app-share-project-input-1" type="checkbox" id="mycheck" name="mycheck" [checked]="member.projectshared" (change)="changeMemberSelection($event, member)">
                    <i class="fas fa-check"></i>
                  </label>
                  <div class="d-grid align-items-center pointer text-capitalize">
                    <span class="ml-2 text-truncate">{{member?.firstname}} {{member?.lastname}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!allTeamMembers?.length">
        <div class="col text-center py-3">
          <div class="wccard">
            <div class="row">
              <div class="col">
                <span class="font-weight-500">
                  No active members in your team
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <span class="f-12 text-danger">{{shareErrorMessage}}</span>
  <div class="row mt-3">
    <div class="col d-flex justify-content-between">
      <span class="font-weight-500 text-9696">
        {{ selectedMembers?.length }} {{ selectedMembers?.length <= 1 ? 'User' : 'Users' }} selected
      </span>
      <button data-testid="auto-app-share-project-button-1" class="btn-trms-small" (click)="shareProject()">Share</button>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg" [innerHtml]="successMessage"></span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg" [innerHtml]="errorMessage"></span>
</ngb-alert>
